import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../../hooks/redux';
import { useCustomSnackbar } from '../../../../hooks/useCustomEnqueueSnackbar';
import { userInfoApi } from '../../../../services/apiServices/user/userInfo';
import { ButtonClassNames, ModalVariants } from '../../../../models/Common';
import { CustomMUIButton } from '../../buttons/CustomMUIButton';
import { modalSlice } from '../../../../store/reducers/ModalSlice';
import { AnimatedIcon } from '../../AnimatedIcon';
import WarningIconLight from '../../../../assets/images/lottieIcons/warning/warning.light.json';
import WarningIconDark from '../../../../assets/images/lottieIcons/warning/warning.dark.json';
import { getErrorMessage } from '../../../../utils';

interface ILeaveAccount {
  userId: number | string | undefined;
  handleClose: () => void;
}

export const LeaveAccount: FC<ILeaveAccount> = ({ userId, handleClose }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { openModal } = modalSlice.actions;
  const { customEnqueueSnackbar } = useCustomSnackbar();
  const [deleteMember, { isLoading }] = userInfoApi.useDeleteMemberAccountMutation();

  const handleContinue = async () => {
    try {
      await deleteMember({ userId: Number(userId) }).unwrap();
      dispatch(
        openModal({
          modalVariants: ModalVariants.Success,
          content: {
            title: `${t('success.balanceHasBeenReplenishedSuccessfully')}`,
            description: `${t('multiAccount.youLeftAccounts')}`,
          },
        }),
      );
    } catch (err) {
      const message = getErrorMessage(err);
      customEnqueueSnackbar(message, 'error');
    }
  };

  return (
    <div className="modals">
      <div className="modals__header modals__header__top-up">
        <AnimatedIcon lightIcon={WarningIconLight} darkIcon={WarningIconDark} className="icon-warning" />
        <article className="modals__header__title">{t('multiAccount.confirmLeave')}</article>
        <p className="modals__header__description">{t('multiAccount.adminLoseAccess')}</p>
      </div>
      <div className="modals__btn-group">
        <CustomMUIButton
          label={t('multiAccount.cancel')}
          handleClick={handleClose}
          className={ButtonClassNames.SecondaryOutlined}
          isBold
        />
        <CustomMUIButton
          label={t('multiAccount.leave')}
          handleClick={handleContinue}
          className={ButtonClassNames.PrimaryFulfilled}
          isLoading={isLoading}
          isBold
        />
      </div>
    </div>
  );
};
